export var QuestionType;
(function (QuestionType) {
    QuestionType["Choice"] = "choice";
    QuestionType["Checkbox"] = "checkbox";
    QuestionType["Boolean"] = "boolean";
    QuestionType["Blank"] = "blank";
    QuestionType["Match"] = "match";
    QuestionType["Order"] = "order";
    QuestionType["Poll"] = "poll";
})(QuestionType || (QuestionType = {}));
//# sourceMappingURL=QuestionComponentValues.js.map